// extracted by mini-css-extract-plugin
module.exports = {"remainedWidthColumn":"ResultsActivitiesTable_remainedWidthColumn__3uSLP","colorColumn":"ResultsActivitiesTable_colorColumn__2WvnF"};